//==============================================
// Block: Image + Content
//==============================================

var initBlockImgContent = function( $block ) {
    
    let blockHeader= $block.find('.block-image-content__title');
    let blockContent = $block.find('.block-image-content__content');
    let blockImgLeft = $block.find('.block-image-overlay--left');
    let blockBarLeft = $block.find('.block-image-bar--left');

    let blockInit = gsap.timeline({
        scrollTrigger: {
            trigger: $block,
            start: 'top 80%',
            //markers: true,
        },
    });

    blockInit.from(blockHeader, {
        duration: 0.5,
        ease: "power1.out",
        opacity: '0',
    })
    .from(blockImgLeft, {
        duration: 1,
        width: '100%',
    })
    .from(blockContent, {
        duration: 0.5,
        opacity: '0'
    })
    .from(blockBarLeft, {
        duration: 0.5,
        ease: "power1.out",
        width: '0',
    });
    

};


// Initialize each block on page load (front end).
$(document).ready(function(){
    $('.block-image-content').each(function(){
        initBlockImgContent( $(this) );
    });
});

/* if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=block-image-content', initBlockImgContent );
} */